import { useImageUrl } from '../api/useImageUrl';

interface Props {
  imageKey: string | null;
  heatmapKey?: string | null;
  showHeatmap?: boolean;
  alt?: string;
}

/** Renders a stored image with an optional heatmap overlay on top. */
export function ImageWithHeatmap({ imageKey, heatmapKey, showHeatmap, alt }: Props) {
  const imgUrl = useImageUrl(imageKey);
  const heatUrl = useImageUrl(showHeatmap ? heatmapKey : null);

  if (!imgUrl) {
    return <div className="dropzone" style={{ minHeight: 200 }}>No image</div>;
  }
  return (
    <div className="image-stack">
      <img src={imgUrl} alt={alt ?? 'inspection'} />
      {showHeatmap && heatUrl && <img className="overlay" src={heatUrl} alt="heatmap" />}
    </div>
  );
}
